module.exports = __webpack_public_path__ + "static/img/9.50fa48d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/9.png
// module id = HbWt
// module chunks = 0